/**
 * Shared style constants for MarketTimelineSelector components.
 * Centralizes repeated values for consistency and maintainability.
 */

/** Monospace font family for numeric/time displays */
export const MONOSPACE_FONT_FAMILY = '"Roboto Mono", monospace'

/** Font sizes used throughout the timeline selector */
export const FONT_SIZE = {
  SMALL: '10px',
  MEDIUM: '12px',
} as const

/** White color variants with different opacity levels */
export const WHITE_ALPHA = {
  FULL: 'common.white',
  HIGH: 'rgba(255, 255, 255, 0.7)',
  MEDIUM: 'rgba(255, 255, 255, 0.5)',
  LOW: 'rgba(255, 255, 255, 0.4)',
  DIVIDER: 'rgba(255, 255, 255, 0.15)',
} as const

/** Status icon size */
export const STATUS_ICON_SIZE = 10
